import { CompanyStatus } from "@kase/my-marathon-communication";
import { computed } from "@preact/signals";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";

const APPROVE_STATUSES = [CompanyStatus.Production, CompanyStatus.Unknown];

export const makeCompany = ({ connection }: ApiSliceParams) => {
    const {
        items,
        allLoaded: loaded,
        listen,
    } = createListController({
        connection,
        list: (con) => con.company.items(),
    });
    const approve = computed(() =>
        items.value.filter(
            (c) =>
                c.active &&
                APPROVE_STATUSES.includes(c.status) &&
                (c.module_bok || c.module_lev),
        ),
    );

    const getByCode = (code: string | null | undefined) => {
        if (!code) {
            return null;
        }

        return items.peek().find((c) => c.code === code) ?? null;
    };

    return {
        items,
        approve,
        loaded,
        listen,
        getByCode,
    };
};
